import { LICENSE_EXPIRED_RETURN_PATH_KEY } from "@frontend-shared/constants";

import { PATHS } from "@/constants/paths";

import { toSafeSameOriginPath } from "./safe-redirect";

// NOTE: NSAI-5413 — the path the license-expired page sends the user back to
// once the license is renewed. It is taken from the address bar, which an
// attacker controls: `https://<app-host>//evil.example` boots the SPA with the
// pathname "//evil.example", and assigning that to `location.href` is a
// protocol-relative navigation off-origin. A `startsWith("/")` check let it
// through, so both the write and the read go through the same-origin guard.

// NOTE: Called by the REST and WebSocket license-expired handlers right before
// they bounce to the license-expired page. An unsafe current location is
// stored as the default destination rather than verbatim.
export const rememberLicenseExpiredReturnPath = (): void => {
  const { pathname, search, hash } = globalThis.location;

  sessionStorage.setItem(
    LICENSE_EXPIRED_RETURN_PATH_KEY,
    toSafeSameOriginPath({
      candidate: `${pathname}${search}${hash}`,
      fallback: PATHS.CHAT,
    }),
  );
};

// NOTE: Re-validated on read too — sessionStorage outlives a deploy, so a value
// written by an older build (or by anything else on the origin) is not trusted.
export const readLicenseExpiredReturnPath = (): string =>
  toSafeSameOriginPath({
    candidate: sessionStorage.getItem(LICENSE_EXPIRED_RETURN_PATH_KEY),
    fallback: PATHS.CHAT,
  });
